import { render } from "./HoraVoz.vue?vue&type=template&id=0e3c6720"
import script from "./HoraVoz.vue?vue&type=script&lang=js"
export * from "./HoraVoz.vue?vue&type=script&lang=js"

import "../../assets/styles/post.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__